import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "job-rates" }
const _hoisted_2 = { class: "job-rates__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Job Rates", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "c-primary-grey" }, "Rates for all job types", -1)
const _hoisted_5 = { class: "m-top-20" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" See our rates for batch jobs submitted through our website or FTP. For our API pricing ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("click here")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_9 = { class: "job-rates__body m-top-15" }
const _hoisted_10 = { class: "job-rates__list" }
const _hoisted_11 = { class: "job-rates__list--left" }
const _hoisted_12 = { class: "job-rates__list--right" }
const _hoisted_13 = {
  key: 0,
  class: "job-rates__avoid"
}
const _hoisted_14 = { class: "icon-avoid-minimal-price" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "m-top-25 m-bottom-30 t-a-c" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("To avoid job minimum cost "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" try our prepayment options")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_JobRatesSlot = _resolveComponent("JobRatesSlot")!
  const _component_IconAvoidMinimalPrice = _resolveComponent("IconAvoidMinimalPrice")!
  const _component_SubscriptionCard = _resolveComponent("SubscriptionCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.pricing)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        class: _normalizeClass(["modal-job-rates", { 'with-avoid': _ctx.profile?.subscription?.plan !== _ctx.SUBSCRIPTION_PLAN.premium }]),
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_router_link, { to: "/api/pricing" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _hoisted_8
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricing, (prices, type, id) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: id }, [
                      ((id + 1) % 2 !== 0)
                        ? (_openBlock(), _createBlock(_component_JobRatesSlot, {
                            key: 0,
                            prices: prices,
                            type: type
                          }, null, 8, ["prices", "type"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricing, (prices, type, id) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: id }, [
                      ((id + 1) % 2 === 0)
                        ? (_openBlock(), _createBlock(_component_JobRatesSlot, {
                            key: 0,
                            prices: prices,
                            type: type
                          }, null, 8, ["prices", "type"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              (_ctx.profile?.subscription?.plan !== _ctx.SUBSCRIPTION_PLAN.premium)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_IconAvoidMinimalPrice)
                    ]),
                    _hoisted_15,
                    _createVNode(_component_SubscriptionCard, {
                      plan: _ctx.selectAvoidPlan(_ctx.profile?.subscription?.plan)
                    }, null, 8, ["plan"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["class", "onClose"]))
    : _createCommentVNode("", true)
}